import { toAbsoluteUrl } from "../../../_metronic/utils/utils";
import BackButton from "../BackButton";

export default function LoginBox({ logo, titulo, subtitulo, children, central, loading, voltar, size, customClass }) {
	return (
		<div className={`div-custom flex-column ${size ?? ''} ${customClass ?? ''}`} >
			{logo && (<img alt="Logo" src={toAbsoluteUrl("/images/logo-dark.png")} style={{ marginLeft: central ? 'auto' : '', marginRight: central ? 'auto' : '' }} />)}

			<div className="flex-column" style={{ alignItems: central ? 'center' : 'self-start', gap: '16px' }}>
				{voltar && (
					typeof voltar === "function"
						? <BackButton onClick={voltar} />
						: <BackButton to={voltar} />
				)}

				<h1>{titulo}</h1>

				<p className="color-gray-7">{subtitulo}</p>
			</div>

			{children}
		</div>
	);
}